import { PagedResult } from '@extrahorizon/javascript-sdk';
import { ActivePeriodConfiguration } from 'models/prescription';
import { RAW_ENDPOINTS, sdk } from 'utils/query';

export const getPrescriptionActivePeriod = async (userId: string) => {
  // FIBWEB-1788 - Part 2/3 - Logic to fetch the Active Period based on the userID
  // User raw call, since I can't find any way to fetch "activePeriod" through sdk.users
  const { data } = await sdk.raw.get<PagedResult<ActivePeriodConfiguration>>(
    `${RAW_ENDPOINTS.PRESCRIPTIONS}/users?id=${userId}`,
  );

  if (!data || data.data.length === 0) {
    return undefined;
  }
  return data?.data[0]?.activePeriods;
};
